'use strict';

var cov_ydrxoz266 = function () {
  var path = 'D:\\freelance\\giutien-viettel\\client-giutien\\src\\app\\guide\\guide.js',
      hash = '07923c0003b009eb159ba8245b914f383851657e',
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: 'D:\\freelance\\giutien-viettel\\client-giutien\\src\\app\\guide\\guide.js',
    statementMap: {
      '0': {
        start: {
          line: 3,
          column: 4
        },
        end: {
          line: 3,
          column: 30
        }
      },
      '1': {
        start: {
          line: 5,
          column: 4
        },
        end: {
          line: 17,
          column: 6
        }
      },
      '2': {
        start: {
          line: 6,
          column: 22
        },
        end: {
          line: 11,
          column: 24
        }
      },
      '3': {
        start: {
          line: 12,
          column: 6
        },
        end: {
          line: 16,
          column: 9
        }
      },
      '4': {
        start: {
          line: 13,
          column: 8
        },
        end: {
          line: 13,
          column: 21
        }
      },
      '5': {
        start: {
          line: 15,
          column: 8
        },
        end: {
          line: 15,
          column: 45
        }
      },
      '6': {
        start: {
          line: 19,
          column: 4
        },
        end: {
          line: 32,
          column: 6
        }
      },
      '7': {
        start: {
          line: 20,
          column: 22
        },
        end: {
          line: 25,
          column: 24
        }
      },
      '8': {
        start: {
          line: 26,
          column: 6
        },
        end: {
          line: 31,
          column: 9
        }
      },
      '9': {
        start: {
          line: 27,
          column: 21
        },
        end: {
          line: 27,
          column: 25
        }
      },
      '10': {
        start: {
          line: 28,
          column: 8
        },
        end: {
          line: 28,
          column: 59
        }
      },
      '11': {
        start: {
          line: 30,
          column: 8
        },
        end: {
          line: 30,
          column: 45
        }
      },
      '12': {
        start: {
          line: 34,
          column: 4
        },
        end: {
          line: 38,
          column: 6
        }
      },
      '13': {
        start: {
          line: 35,
          column: 6
        },
        end: {
          line: 37,
          column: 9
        }
      },
      '14': {
        start: {
          line: 36,
          column: 8
        },
        end: {
          line: 36,
          column: 48
        }
      },
      '15': {
        start: {
          line: 40,
          column: 4
        },
        end: {
          line: 44,
          column: 6
        }
      },
      '16': {
        start: {
          line: 41,
          column: 6
        },
        end: {
          line: 43,
          column: 9
        }
      },
      '17': {
        start: {
          line: 42,
          column: 8
        },
        end: {
          line: 42,
          column: 48
        }
      },
      '18': {
        start: {
          line: 48,
          column: 0
        },
        end: {
          line: 56,
          column: 5
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 2,
            column: 2
          },
          end: {
            line: 2,
            column: 3
          }
        },
        loc: {
          start: {
            line: 2,
            column: 77
          },
          end: {
            line: 45,
            column: 3
          }
        },
        line: 2
      },
      '1': {
        name: '(anonymous_1)',
        decl: {
          start: {
            line: 5,
            column: 30
          },
          end: {
            line: 5,
            column: 31
          }
        },
        loc: {
          start: {
            line: 5,
            column: 44
          },
          end: {
            line: 17,
            column: 5
          }
        },
        line: 5
      },
      '2': {
        name: '(anonymous_2)',
        decl: {
          start: {
            line: 12,
            column: 35
          },
          end: {
            line: 12,
            column: 36
          }
        },
        loc: {
          start: {
            line: 12,
            column: 41
          },
          end: {
            line: 14,
            column: 7
          }
        },
        line: 12
      },
      '3': {
        name: '(anonymous_3)',
        decl: {
          start: {
            line: 14,
            column: 9
          },
          end: {
            line: 14,
            column: 10
          }
        },
        loc: {
          start: {
            line: 14,
            column: 15
          },
          end: {
            line: 16,
            column: 7
          }
        },
        line: 14
      },
      '4': {
        name: '(anonymous_4)',
        decl: {
          start: {
            line: 19,
            column: 26
          },
          end: {
            line: 19,
            column: 27
          }
        },
        loc: {
          start: {
            line: 19,
            column: 40
          },
          end: {
            line: 32,
            column: 5
          }
        },
        line: 19
      },
      '5': {
        name: '(anonymous_5)',
        decl: {
          start: {
            line: 26,
            column: 35
          },
          end: {
            line: 26,
            column: 36
          }
        },
        loc: {
          start: {
            line: 26,
            column: 41
          },
          end: {
            line: 29,
            column: 7
          }
        },
        line: 26
      },
      '6': {
        name: '(anonymous_6)',
        decl: {
          start: {
            line: 29,
            column: 9
          },
          end: {
            line: 29,
            column: 10
          }
        },
        loc: {
          start: {
            line: 29,
            column: 15
          },
          end: {
            line: 31,
            column: 7
          }
        },
        line: 29
      },
      '7': {
        name: '(anonymous_7)',
        decl: {
          start: {
            line: 34,
            column: 20
          },
          end: {
            line: 34,
            column: 21
          }
        },
        loc: {
          start: {
            line: 34,
            column: 32
          },
          end: {
            line: 38,
            column: 5
          }
        },
        line: 34
      },
      '8': {
        name: '(anonymous_8)',
        decl: {
          start: {
            line: 35,
            column: 70
          },
          end: {
            line: 35,
            column: 71
          }
        },
        loc: {
          start: {
            line: 35,
            column: 81
          },
          end: {
            line: 37,
            column: 7
          }
        },
        line: 35
      },
      '9': {
        name: '(anonymous_9)',
        decl: {
          start: {
            line: 40,
            column: 17
          },
          end: {
            line: 40,
            column: 18
          }
        },
        loc: {
          start: {
            line: 40,
            column: 29
          },
          end: {
            line: 44,
            column: 5
          }
        },
        line: 40
      },
      '10': {
        name: '(anonymous_10)',
        decl: {
          start: {
            line: 41,
            column: 67
          },
          end: {
            line: 41,
            column: 68
          }
        },
        loc: {
          start: {
            line: 41,
            column: 78
          },
          end: {
            line: 43,
            column: 7
          }
        },
        line: 41
      }
    },
    branchMap: {},
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0
    },
    f: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0
    },
    b: {},
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var GuideController = function GuideController($scope, $http, $rootScope, $mdDialog, $state, myVars, $window) {
  _classCallCheck(this, GuideController);

  ++cov_ydrxoz266.f[0];
  ++cov_ydrxoz266.s[0];

  $scope.checkinfo = myVars;

  ++cov_ydrxoz266.s[1];
  $scope.showCancelDialog = function (ev) {
    ++cov_ydrxoz266.f[1];

    var confirm = (++cov_ydrxoz266.s[2], $mdDialog.confirm().title('Quý khách có muốn hủy DV Đấu giá ngược ? ').textContent('').targetEvent(ev).ok('Có').cancel('Không'));
    ++cov_ydrxoz266.s[3];
    $mdDialog.show(confirm).then(function () {
      ++cov_ydrxoz266.f[2];
      ++cov_ydrxoz266.s[4];

      $scope.huy();
    }, function () {
      ++cov_ydrxoz266.f[3];
      ++cov_ydrxoz266.s[5];

      $state.go('app', {}, { reload: true });
    });
  };

  ++cov_ydrxoz266.s[6];
  $scope.showDkDialog = function (ev) {
    ++cov_ydrxoz266.f[4];

    var confirm = (++cov_ydrxoz266.s[7], $mdDialog.confirm().title('Bạn có chắc chắn muốn đăng ký dịch vụ ').textContent('').targetEvent(ev).ok('Có').cancel('Không'));
    ++cov_ydrxoz266.s[8];
    $mdDialog.show(confirm).then(function () {
      ++cov_ydrxoz266.f[5];

      var data = (++cov_ydrxoz266.s[9], true);
      ++cov_ydrxoz266.s[10];
      $rootScope.$emit('CallMethodRegister', { ev: ev, data: data });
    }, function () {
      ++cov_ydrxoz266.f[6];
      ++cov_ydrxoz266.s[11];

      $state.go('app', {}, { reload: true });
    });
  };

  ++cov_ydrxoz266.s[12];
  $scope.dangky = function () {
    ++cov_ydrxoz266.f[7];
    ++cov_ydrxoz266.s[13];

    $http.post($rootScope.apiOpen + 'dangky/' + myVars.msisdn).then(function (results) {
      ++cov_ydrxoz266.f[8];
      ++cov_ydrxoz266.s[14];

      $window.location = results.data.message;
    });
  };

  ++cov_ydrxoz266.s[15];
  $scope.huy = function () {
    ++cov_ydrxoz266.f[9];
    ++cov_ydrxoz266.s[16];

    $http.post($rootScope.apiOpen + 'huy/' + myVars.msisdn).then(function (results) {
      ++cov_ydrxoz266.f[10];
      ++cov_ydrxoz266.s[17];

      $window.location = results.data.message;
    });
  };
};

++cov_ydrxoz266.s[18];


angular.module('app').component('guide', {
  templateUrl: 'app/guide/guide.html',
  controller: GuideController,
  bindings: {
    guideData: "<"
  }
});